import GameUtil from "../utility/game_util"
import ModelData from "../pacakge/public/model_data"
import * as CryptoJS from 'crypto-js';
import AppData from '../pacakge/public/const/app_data';
import LogManager from "./log_manager";

export default class OssManager{
    protected static m_instance: OssManager = null
    static get instance() {
        if (!OssManager.m_instance) {
            OssManager.m_instance = new OssManager()
        }
        return OssManager.m_instance;
    }    

    private _ossParams: any = null
    public getOssParams(success, fail){
        if(this._ossParams){
            let date = new Date(this._ossParams.expiration)
            let nowDate = new Date()
            if(date.getTime() > nowDate.getTime() + 10 * 1000){
                success && success(this._ossParams)
                return
            }            
        }
        this.requestOssParams((data) => {
            this._ossParams = data
            success && success(data)
        }, (err) => {
            this._ossParams = null
            fail && fail(err)
        })
    }


    private requestOssParams(success, fail){
        let id = ModelData.instance.roleData.id
        let requestData: IHttpRequestData = {
            baseUrl: "cdn/requestAssumeRole?",
            params: {
                userId: id,
            },
            logRecord : AppData.testMode
        }
        if (id == null || id == 0) {
            requestData.params["userId"] = LogManager.instance.uploadLogFileTempUid
            requestData.params["gameUserId"] = LogManager.instance.uploadLogFileTempUid
            requestData.token = LogManager.instance.uploadLogFileTempToken
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail(retData)
        })
    }

    upload_jpg(key: string, bytes: Uint8Array, onFinish: Function, onErrr: Function, uploadTimes?: number){
        key = `image/${key}`
        this.upload_file(key, bytes, onFinish, onErrr, uploadTimes, 'image/jpeg')
    }

    upload_log(key: string, bytes: Uint8Array, onFinish: Function, onErrr: Function, uploadTimes?: number){
        key = `log/${key}`
        this.upload_file(key, bytes, onFinish, onErrr, uploadTimes)
    }

    upload_file(key: string, bytes: Uint8Array, onFinish: Function, onErrr: Function, uploadTimes?: number, contentType?: any){
        this.getOssParams((params) => {
            key = `files/${key}`
            let contentLength = bytes.length
            let contentMD5 = this.calcMd5(bytes)
            let utcGMT = this.getUtcGMT()
            contentType = contentType || 'application/octet-stream'
            let canonicalizedOSSHeaders = `x-oss-security-token:${params.securityToken}\n`
            let canonicalizedResource = `/${params.bucket}/${key}`
            let host = `${params.bucket}.${params.endpoint}`
            let authorization = this.getAuthorization('PUT', contentMD5, contentType, utcGMT, canonicalizedOSSHeaders, canonicalizedResource, params.accessKeySecret, params.accessKeyId)
            let url = `http://${host}/${key}`
            if(key.indexOf('http') >= 0){
                url = key
            }
            let requestData: IHttpRequestData = {
                baseUrl: url,
                
            }
            let header = {
                ['Content-Encoding']: 'utf-8',
                ['Content-Md5']: contentMD5,
                ['Content-Disposition']: 'attachment;filename=' + key,
                ['Date']: utcGMT,
                ['Content-Length']: contentLength,
                ['Host']: host,
                ['Authorization']: authorization,
                ['Content-Type']: contentType,
                ['x-oss-security-token']: params.securityToken
            }
            //发送图片消息时去掉 "Content-Disposition"   有"Content-Disposition" 在浏览器打开是下载
            if(contentType == "image/jpeg"){
                delete header["Content-Disposition"]
            }
    
            uploadTimes = uploadTimes || 5
            GameUtil.http_put(requestData, header, bytes, function(rsp){
                onFinish && onFinish(url)
            }, function(err){
                onErrr && onErrr(err)
            })
        }, (err) => {
            onErrr && onErrr(err)
        })        
    }

    private ToHMACSHA1_Base64(key: string, data: string): string{
        return CryptoJS.HmacSHA1(data, key).toString(CryptoJS.enc.Base64)
    }

    private getAuthorization(method: string, contentMD5: string, contentTpye: string, utcGMT: any, canonicalizedOSSHeaders: string, canonicalizedResource: string, accessKeySecret: string, accessKeyId: string): string{
        utcGMT = utcGMT || this.getUtcGMT()
        let data = `${method}\n${contentMD5}\n${contentTpye}\n${utcGMT}\n${canonicalizedOSSHeaders}${canonicalizedResource}`
        let signature = this.ToHMACSHA1_Base64(accessKeySecret, data)
        return `OSS ${accessKeyId}:${signature}`
    }

    private getUtcGMT(){
        let date = new Date()
        cc.log(date)
        return date.toUTCString()
    }
    

    private calcMd5(bytes: Uint8Array | string): string{
        return CryptoJS.MD5(CryptoJS.lib.WordArray.create(bytes)).toString(CryptoJS.enc.Base64)
    }
    
}